import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { AppOAuthStore } from '../models/AppOAuthSotarge';
import { DialogConfirmacion } from '../shared/dialogs/confirmacion/dialogConfirmacion.component';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IDispositivoAutorizado } from '../pages/ModuloSeguridad/DispositivosAutorizados/interfaces/dispositivo-autorizado-interface';


@Injectable({
    providedIn: 'root'
})

export class httpConnect{
    private isDev = !environment.production;
    //private urlService = this.isDev ? '/' : 'services/';
    private urlService = environment.baseUrl + '/';


    private headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8;', 
                                      'Accept': 'application/json, text/javascript, /;'
                                    }); 
    // public headersWithAuth = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 
    //                                   'Accept': 'application/json, text/javascript, /;',
    //                                   "Authorization": 'Bearer ' + this.myStorage.getItem('token') 
    //                                 });  

    constructor(private _http : HttpClient, 
                private myStorage: AppOAuthStore, 
                public dialog : MatDialog, 
                private router: Router){
    }

    public postLogAPI(controller: string, action: string, params : any) : Observable<any>{
        let headersAuth = this.headers.set("Authorization", "Bearer " + this.myStorage.getItem('token')??'');
        let dispositivoAutorizado:IDispositivoAutorizado|null=null;
        try {
            dispositivoAutorizado = this.myStorage.getObject('dispositivoAutorizado');
        } catch (error) {
            dispositivoAutorizado = null;
        }

        if(dispositivoAutorizado!=null)
            headersAuth= headersAuth.append('x-key-token',dispositivoAutorizado.key_uuid);

        return this._http.post(this.urlService + 'api/' + controller + '/' + action, params, { headers: headersAuth });        
    }

    public postAPI(controller: string, action: string, params : any, files? : boolean) : Observable<any>{
        let headersAuth = this.headers.set("Authorization", "Bearer " + this.myStorage.getItem('token'));
        return this._http.post(this.urlService + 'api/' + controller + '/' + action, params, { headers: headersAuth })
        .pipe(
            map((data: any) => {
                return data;
            })
            ,catchError( err => {
                if (err.status == 401) {
                    this.Confirmacion({
                        titulo:'Atención',
                        msg : "Su sesión ha expirado. \nEs necesario volver a iniciar sesión.",
                        tipo : 4 ,
                        ventana : 1
                    })     
                }
                return throwError(err);
            })
        );
    }
    
    private Confirmacion(dataConfirm: any) {
        let dialogRef = this.dialog.open(DialogConfirmacion, {
            data: {
                titulo: dataConfirm.titulo,
                mensaje: dataConfirm.msg,
                tipo: dataConfirm.tipo
            },
            disableClose: true,
            panelClass: "dialog-responsive-cat"
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.dialog.closeAll();
                this.router.navigate(['/']);   
            }
        });
    }
}